import { render, staticRenderFns } from "./ModalEstadoTransaccion.vue?vue&type=template&id=12ced96e&scoped=true"
import script from "./ModalEstadoTransaccion.vue?vue&type=script&lang=js"
export * from "./ModalEstadoTransaccion.vue?vue&type=script&lang=js"
import style0 from "./ModalEstadoTransaccion.vue?vue&type=style&index=0&id=12ced96e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ced96e",
  null
  
)

export default component.exports